import { getUserLang } from '../../lib/helper';
import { LocalizationService } from '../localization.service';
import { IInjectedServices } from './injected-services';

export default function createServices(pathname: string): IInjectedServices {
	
	const localizationService = new LocalizationService(getUserLang(pathname));

	return { localizationService };
}
